import React, { useState, useEffect } from "react";
import {
  Modal,
  Button,
  Form,
  InputGroup,
  ListGroup,
  ListGroupItem,
} from "react-bootstrap";
import SearchIcon from "@mui/icons-material/Search";

function EditGroupModal({ show, handleClose, group, onSave, allUsers }) {
  const [groupName, setGroupName] = useState(group.name);
  const [selectedUsers, setSelectedUsers] = useState(
    group.group_accounts.map((account) => account.account_id)
  );
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    if (show) {
      setGroupName(group.name);
      setSelectedUsers(
        group.group_accounts.map((account) => account.account_id)
      );
      setSearchQuery("");
    }
  }, [group, show]);

  const handleToggle = (event, userId) => {
    event.preventDefault();
    const currentIndex = selectedUsers.indexOf(userId);
    const newChecked = [...selectedUsers];

    if (currentIndex === -1) {
      newChecked.push(userId);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setSelectedUsers(newChecked);
  };

  const handleSave = () => {
    onSave(group.id, groupName, selectedUsers);
    handleClose();
  };

  const filteredUsers = allUsers.filter((user) =>
    user.email.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Gruppe bearbeiten</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3" controlId="group-name">
            <Form.Label>Gruppenname</Form.Label>
            <Form.Control
              type="text"
              placeholder="Gruppenname eingeben"
              value={groupName}
              onChange={(e) => setGroupName(e.target.value)}
            />
          </Form.Group>
          <Form.Group className="mb-2" controlId="user-search">
            <InputGroup>
              <InputGroup.Text style={{ backgroundColor: "#fff" }}>
                <SearchIcon fontSize="small" style={{ color: "#999" }} />
              </InputGroup.Text>
              <Form.Control
                type="text"
                placeholder="Benutzer suchen..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </InputGroup>
          </Form.Group>
          <ListGroup style={{ maxHeight: "400px", overflowY: "auto" }}>
            {filteredUsers.map((user) => (
              <ListGroupItem
                key={user.id}
                action
                onClick={(e) => handleToggle(e, user.id)}
              >
                <Form.Check
                  type="checkbox"
                  checked={selectedUsers.includes(user.id)}
                  label={user.email}
                  onChange={() => {}}
                />
              </ListGroupItem>
            ))}
          </ListGroup>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Schließen
        </Button>
        <Button variant="primary" onClick={handleSave}>
          Speichern
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default EditGroupModal;
